import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { getErrorMessage } from "@/lib/errors";

/** Delete an unused procurement document (only shown while it can still be deleted). */
export function DeleteDocButton({ path, label, number, status, allowed = ["DRAFT", "REJECTED", "CANCELLED"], onDeleted }) {
  if (!allowed.includes(status)) return null;
  const remove = async () => {
    if (!window.confirm(`Delete ${label} ${number}? This can't be undone.`)) return;
    try {
      await api.delete(path);
      toast.success(`${label} ${number} deleted`);
      onDeleted?.();
    } catch (err) {
      toast.error(getErrorMessage(err));
    }
  };
  return (
    <Button size="sm" variant="ghost" title={`Delete this ${label.toLowerCase()}`} onClick={remove} data-testid={`delete-${number}`}>
      <Trash2 className="h-3.5 w-3.5 text-rose-400" />
    </Button>
  );
}
